export const BORDER_HEIGHT = 5;
export const PADDING = 12;
export const FONT_SIZE = 12;
export const FONT_FAMILY = "Poppins";

// Pinned column constants
export const COLUMN_HEIGHT = 24;
export const COLUMN_PADDING = 10;
export const COLUMN_WIDTH = 104;

export const COLUMN_BLACKLIST = new Set<string>(["file", "dependency", "subtasks", "name"]);

// Updates constants
export const AVATAR_SIZE = 18;
